<script>
export default {
  name: 'ModalFormFeedback',
  props: {
    success: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.timeout = setTimeout(() => this.$emit('close-feedback'), 3000);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>

<template>
  <div class="modal-wrap">
    <div class="modal" :class="success ? 'green' : 'red'">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.8657 10.4002L4.34959 2.27112C4.22747 2.20274 4.08738 2.17325 3.94805 2.18661C3.80873 2.19997 3.6768 2.25554 3.5699 2.34588C3.463 2.43623 3.38622 2.55705 3.34982 2.6922C3.31343 2.82735 3.31915 2.97039 3.36622 3.1022L6.10428 10.7688C6.15769 10.9183 6.15769 11.0817 6.10428 11.2312L3.36622 18.8978C3.31915 19.0296 3.31343 19.1726 3.34982 19.3078C3.38622 19.443 3.463 19.5638 3.5699 19.6541C3.6768 19.7445 3.80873 19.8 3.94806 19.8134C4.08738 19.8267 4.22747 19.7973 4.34959 19.7289L18.8657 11.5998C18.9723 11.5401 19.0611 11.4531 19.1229 11.3476C19.1847 11.2422 19.2173 11.1222 19.2173 11C19.2173 10.8778 19.1847 10.7578 19.1229 10.6524C19.0611 10.5469 18.9723 10.4599 18.8657 10.4002V10.4002Z"
          :stroke="[success ? '#3AB55B' : '#eb4e2c']"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.1875 11H11.6875"
          :stroke="[success ? '#3AB55B' : '#eb4e2c']"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <slot name="message"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal-wrap {
  position: fixed;
  bottom: 5%;
  left: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 10000;
}
.modal {
  width: 50%;
  margin: 0 auto;
  padding: 10px 20px;
  border-radius: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7.5px;

  font-size: var(--fs-5-3);
  font-weight: 400;
}
.green {
  color: #39b45a;
  background-color: #d6f5dd;
  border: 2px solid #39b45a;
}

.red {
  color: #eb4e2c;
  background-color: #fcedea;
  border: 2px solid #eb4e2c;
}
</style>
